import { useState } from "react";

import { makePutApiCall } from "../../../shared/makeApiCall";
import { SnackbarData, SnackbarType } from "../../../components/Snackbar";
import { generateUniqueNumber } from "../../../shared/utility";
import ModelErrorComponent from "../../../components/modals/ModelErrorComponent";

export function UserViewModel(addSnackbar, logout) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(true);

  const user_id = localStorage.getItem("id");

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const updateAccountPassword = async function (values) {
    setLoading(true);
    let callResult = await makePutApiCall(`updatePassword/${user_id}`, values);

    setLoading(false);
    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  return { emptyModal, updateAccountPassword, setEmptyModelOpen };
}
